import { apiClient, BillSubscription, PatchBillSubscriptionsRequest } from '@melio/javascript-sdk';
import { BillSubscriptionsApiGetBillSubscriptionsRequest } from '@melio/platform-api-axios-client';

import { useMelioQueryClient, useModelApi, UseModelApiProps } from '../../core';
import { useDeleteMutation } from '../../core/useDeleteMutation';
import { useUpdateMutation } from '../../core/useUpdateMutation';
import { BillSubscriptionModel } from './types';
import { convertBillSubscriptionCentsToDollars, convertPatchBillSubscriptionRequestDollarsToCents } from './utils';

type UseBillSubscriptionProps = UseModelApiProps<BillSubscription> & {
  params?: BillSubscriptionsApiGetBillSubscriptionsRequest;
};

export const useBillSubscription = ({ params, ...props }: UseBillSubscriptionProps): BillSubscriptionModel => {
  const queryClient = useMelioQueryClient();
  const client = apiClient.billSubscriptions();
  const query = useModelApi<BillSubscription, PatchBillSubscriptionsRequest>({
    ...props,
    queryKey: ['bill-subscription', params],
    queryFn: () => client.get(props.id as string, params),
    select: convertBillSubscriptionCentsToDollars,
  });

  const update = useUpdateMutation<BillSubscription, PatchBillSubscriptionsRequest>(
    (data) => client.update(props.id as string, convertPatchBillSubscriptionRequestDollarsToCents(data), params),
    query,
    {
      onSuccess: () => {
        void queryClient.invalidateQueries('VendorsApi');
      },
    }
  );

  const cancel = useDeleteMutation<BillSubscription>(() => client.cancel(props.id as string), query);

  return {
    ...query,
    update,
    delete: cancel,
  };
};
